import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <g id="prefix__Layer_1">
      <path
        d="M23 0h-6v1h5.29l-9.14 9.15.7.7L23 1.71V7h1V0z"
        fill={ fill }
      />
      <path
        fill={ fill }
        d="M23 22c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h9V0H2C.9 0 0 .9 0 2v20c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2v-9h-1v9z"
      />
    </g>
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string.isRequired
};

export default SvgComponent;
